
export const systemOwnerPermissions: UserPermission[] = [
    {
        name: "Monitoring",
        route: "monitoring",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Dashboard",
        route: "dashboard",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Transactions",
        route: "transactions",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Alarm Viewer",
        route: "alarms",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Enrolment",
        route: "enrolment",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Companies",
        route: "companies",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Categories",
        route: "categories",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Departments",
        route: "departments",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Access Groups",
        route: "access-groups",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Floor Group",
        route: "floor-group",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Oss Group",
        route: "oss-group",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Access Profiles",
        route: "access-profiles",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Access Areas",
        route: "access-areas",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Lift Area",
        route: "lift-area",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Access Time Patterns",
        route: "access-time-patterns",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "New Accounts",
        route: "account-setup",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Card Formats",
        route: "card-formats",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Notifications",
        route: "notifications",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Hardware",
        route: "hardware",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Engine",
        route: "engine",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Presets",
        route: "presets",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Doors",
        route: "doors",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Zones",
        route: "zones",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Common Zones",
        route: "common-zones",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Device Time Patterns",
        route: "device-time-patterns",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Reports",
        route: "reports",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Transaction",
        route: "transaction-report",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Reports",
        route: "transaction-reports",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Reports",
        route: "time-attendance-reports",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Time & Attendance",
        route: "time-attendance-report",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Reports",
        route: "my-report",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "My Reports",
        route: "my-reports",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Reports",
        route: "access-control-reports",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Access Control",
        route: "access-control-report",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Reports",
        route: "system-setup-reports",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "System Setup",
        route: "system-setup-report",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Reports",
        route: "emergency-safety-reports",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Emergency & Safety",
        route: "emergency-safety-report",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Reports",
        route: "compliance-reports",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Compliance",
        route: "compliance-report",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Operators",
        route: "operators",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Login",
        route: "logins",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Permissions",
        route: "permissions",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Configuration",
        route: "configuration",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Time Triggered Actions",
        route: "time-triggered-actions",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Reason Codes",
        route: "reason-codes",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Accounts",
        route: "accounts",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Sites",
        route: "sites",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Buildings",
        route: "buildings",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Floors",
        route: "floors",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Lifts",
        route: "lifts",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Messages",
        route: "messages",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "General Messages",
        route: "general",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: 'Biometric Messages',
        route: 'biometric-message',
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Holidays",
        route: "holidays",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Reader preset",
        route: "reader-preset",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "controller preset",
        route: "controller-preset",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "biometric preset",
        route: "biometric-preset",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "device preset",
        route: "device-preset",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "lock preset",
        route: "lock-preset",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    // {
    //     name: "locker preset",
    //     route: "locker-preset",
    //     showListItem: true,
    //     addElements: true,
    //     deleteElements: true,
    //     updateElements: true
    // },
    {
        name: "company",
        route: "company",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "personnel",
        route: "personnel",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "category",
        route: "category",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Master Controller",
        route: "master-controller",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "I/O & Modules",
        route: "io-module",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Reader",
        route: "reader",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "lock",
        route: "lock",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "locker",
        route: "locker",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Oss Device",
        route: "oss-device",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Security Policies",
        route: "security-policies",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Security Policy",
        route: "security-policy",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Events",
        route: "events",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    // {
    //     name: "Modules",
    //     route: "modules",
    //     showListItem: true,
    //     addElements: true,
    //     deleteElements: true,
    //     updateElements: true
    // },
    {
        name: "Compliance condition",
        route: "compliance-condition",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Operational Compliance",
        route: "operational-compliance",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    }
    // {
    //     name: "Scheduled Tours",
    //     route: "scheduled-tours",
    //     showListItem: true,
    //     addElements: true,
    //     deleteElements: true,
    //     updateElements: true
    // }
]
